import { ClipboardList, Search } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  filtered: boolean
}

export default function ActivityEmptyState({ filtered }: Props) {
  const { t } = useTranslation('activity')
  const Icon = filtered ? Search : ClipboardList

  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <div className="animate-float mb-4">
        <Icon size={40} className="text-gold/30" />
      </div>
      <h3 className="font-display text-ivory text-base font-semibold mb-1">
        {filtered ? t('empty.filteredTitle') : t('empty.title')}
      </h3>
      <p className="text-pearl/60 text-sm leading-relaxed max-w-[240px]">
        {filtered ? t('empty.filteredDescription') : t('empty.description')}
      </p>
    </div>
  )
}
